import { menuListItems } from 'assets/menu/menuList';
import { BreadCrumb } from 'components/BreadCrumb';
import { GoToBack } from 'components/GoToBack';
import { Header } from 'components/Header';
import { Menu } from 'components/Menu';
import React from 'react';
import { useParams } from 'react-router-dom';
import { SessionForm } from '../SessionForm';
import { HeaderContainer } from './styles';

export const SessionNew: React.FC = () => {
  const { eventId } = useParams<{ eventId: string }>();

  return (
    <Menu links={menuListItems}>
      <Header>
        <HeaderContainer>
          <div>
            <GoToBack />
          </div>

          <div className="header-text">
            <BreadCrumb 
              itens={["Eventos", "Detalhes", "Nova Sessão"]} 
              itemActive="Nova Sessão" 
            />
          </div>
        </HeaderContainer>
      </Header>

      <SessionForm eventId={eventId} />
    </Menu>
  );
}; 